var _excluded = ["colors", "hoverImageProps", "href", "imageProps", "onSwatchClick", "onProductClick", "totalProductTileCount"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Pill from '../pill';
import Price from '../price';
import ProductTile from '../product-tile';
import ProductTileSwatches from '../product-tile-swatches';
import Image from '../image';
var ProductTileWithSwatches = _ref => {
  var {
      colors,
      hoverImageProps,
      href,
      imageProps,
      onSwatchClick,
      onProductClick,
      totalProductTileCount
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var [selectedSwatchIndex, setSelectedSwatchIndex] = useState(0);
  var {
    analyticsAttributes,
    imageUrl,
    hoverImageUrl
  } = (colors === null || colors === void 0 ? void 0 : colors[selectedSwatchIndex]) || {};
  var swatches = colors.map(color => color.swatch);
  var pdpHref = href;
  if (process.browser && colors.length) {
    var _colors$selectedSwatc, _colors$selectedSwatc2;
    // append selected color to PDP link on client-side
    var [path, search] = href.split('?');
    var params = new URLSearchParams(search);
    params.set('color', (_colors$selectedSwatc = colors[selectedSwatchIndex]) === null || _colors$selectedSwatc === void 0 ? void 0 : (_colors$selectedSwatc2 = _colors$selectedSwatc.swatch) === null || _colors$selectedSwatc2 === void 0 ? void 0 : _colors$selectedSwatc2.id);
    pdpHref = "".concat(path, "?").concat(params);
  }
  return /*#__PURE__*/React.createElement(ProductTile, _extends({
    imageProps: _objectSpread(_objectSpread({}, imageProps), {}, {
      src: (imageProps === null || imageProps === void 0 ? void 0 : imageProps.src) || imageUrl
    }),
    hoverImageProps: ((hoverImageProps === null || hoverImageProps === void 0 ? void 0 : hoverImageProps.src) || hoverImageUrl) && _objectSpread(_objectSpread({}, hoverImageProps), {}, {
      src: (hoverImageProps === null || hoverImageProps === void 0 ? void 0 : hoverImageProps.src) || hoverImageUrl
    }),
    href: pdpHref,
    swatches: swatches.length && /*#__PURE__*/React.createElement(ProductTileSwatches, {
      analyticsAttributes: analyticsAttributes,
      swatches: swatches,
      selectedIndex: selectedSwatchIndex,
      onSelect: setSelectedSwatchIndex,
      onSwatchClick: onSwatchClick
    }),
    onProductClick: onProductClick,
    totalProductTileCount: totalProductTileCount
  }, otherProps));
};
ProductTileWithSwatches.propTypes = {
  /** Defines HTML attributes for link tracking (e.g., { "data-lulu-track": "pdp-link" }) (ProductTile prop) */
  analyticsAttributes: PropTypes.shape({}),
  /** Optional classname for the product tile. (ProductTile prop)  */
  className: PropTypes.string,
  /** The number of colors available for the product.
  If using swatches, this should usually match the swatches length (ProductTile prop) */
  colorCount: PropTypes.number,
  colors: PropTypes.arrayOf(PropTypes.shape({
    analyticsAttributes: PropTypes.shape({}),
    hoverImageUrl: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    swatch: PropTypes.shape({
      id: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
      name: PropTypes.string.isRequired
    }).isRequired
  })),
  /** Content inserted at the bottom of the product tile for non-standard use cases (ProductTile prop) */
  footerContent: PropTypes.node,
  /** Used to populate additional props to product hover image (Accepts same props list as <Image /> component) */
  hoverImageProps: PropTypes.shape(_objectSpread(_objectSpread({}, Image.propTypes), {}, {
    className: PropTypes.string,
    maxWidth: PropTypes.number,
    src: PropTypes.string
  })),
  /** URL to the PDP (ProductTile prop)  */
  href: PropTypes.string.isRequired,
  /** Used to populate additional props to product image (Accepts same props list as <Image /> component) */
  imageProps: PropTypes.shape(_objectSpread(_objectSpread({}, Image.propTypes), {}, {
    className: PropTypes.string,
    maxWidth: PropTypes.number,
    src: PropTypes.string
  })),
  /** Product name (ProductTile prop)  */
  name: PropTypes.string.isRequired,
  /** Accepts same props list as <Pill /> component (ProductTile prop) */
  pillProps: PropTypes.shape(_objectSpread({}, Pill.propTypes)),
  /** Content inserted after the product image for non-standard use cases (ProductTile prop) */
  postImageContent: PropTypes.node,
  /** Accepts same props list as <Price /> component (ProductTile prop) */
  priceProps: PropTypes.shape(_objectSpread({}, Price.propTypes)).isRequired,
  /** Allows color swatches to be displayed onHover (ProductTile prop) */
  showColorsOnHover: PropTypes.bool,
  onSwatchClick: PropTypes.func,
  onProductClick: PropTypes.func,
  /**total productTiles count for analytics*/
  totalProductTileCount: PropTypes.number
};
ProductTileWithSwatches.defaultProps = {
  analyticsAttributes: {},
  className: '',
  colors: [],
  colorCount: null,
  footerContent: null,
  hoverImageProps: {},
  imageProps: {},
  pillProps: null,
  postImageContent: null,
  showColorsOnHover: false,
  onSwatchClick: () => {},
  onProductClick: () => {},
  totalProductTileCount: 0
};
export default ProductTileWithSwatches;